module.exports = __webpack_public_path__ + "static/media/13_profil.8e1db6bb.png";